import Image from "next/image";

import WhiteLogo from "./../../public/images/Ico-LOGO/white.png";
import { useState } from "react";
import ContactForm from "../../components/contact/ContactForm";
import Address from "../../components/contact/address";
import DoneForYouContactForm from "../../components/done-for-you/done_for_you_contact";
import Meta from "../../components/Meta";
import SecondDescripton from "../../components/common/SecondDescripton";

const ShowcaseMyImpact = () => {
  const [video, setVideo] = useState(false);
  const [url, setUrl] = useState(null);
  return (
    <>
      <Meta title=" Showcase my impact || Impactoverse"></Meta>
      {/* <!-- Hero --> */}
      <section className="relative py-24 max-sm:py-10">
        <div className="container">
          {/* Start global distribute and dao idea */}
          <div className="lg:flex lg:space-x-12">
            <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
              <Image
                width={1519}
                height={935}
                src="/images/gradient.jpg"
                alt="gradient"
                className="h-full w-full object-cover"
              />
            </picture>
            <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
              <Image
                width={1519}
                height={935}
                src="/images/gradient_dark.jpg"
                alt="gradient dark"
                className="h-full w-full object-cover"
              />
            </picture>
          </div>
          <div>
            <div className="dark:hidden">
              <Image
                src={WhiteLogo}
                height={42}
                width={195}
                className="mx-auto flex top-0 z-10 bg-blue-500 rounded-md animate-spin-faux3d"
                alt="Impactoverse | Impact Ecosystem"
              />
            </div>
            <div className="hidden dark:block">
              <Image
                src={WhiteLogo}
                height={42}
                width={195}
                className="mx-auto flex top-0 z-10 bg-blue-500 rounded-md animate-spin-faux3d"
                alt="Impactoverse | Impact Ecosystem"
              />
            </div>

            <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
              REACH
              <span className="animate-gradient"> OUT</span>
            </h1>
            <SecondDescripton text={`We’re here to help. Whether you’re looking to learn more, explore a partnership, or ask a question, feel free to get in touch. We’ll do our best to respond within 1–2 working days.`}></SecondDescripton>
            {/* <p className="text-lg mb-10 dark:text-jacarta-300 text-center">
            Align with impact initiatives in our IMPACT DOT campaigns or step into our WORLD OF IMPACT. Check out the video below and if you’re interested, drop us a line, and we’ll get in touch to explore the options that work best for you.
            </p> */}
          </div>

        </div>
      </section>





      <section className="py-10 dark:bg-jacarta-800 bg-light-base">

        <div className="container">


          {/* <!-- Contact Form --> */}
          <div className="lg:flex">
            {/* <!-- Contact Form --> */}


            {/* <!-- Info --> */}
            {/* <Address title={"REACH OUT"} description={"If you're interested in joining the ecosystem, exploring how to contribute or collaborate, or simply want to find out more, get in touch. We’d love to connect. "} /> */}
            <div className="md:my-10 lg:mb-10 lg:w-2/3 lg:pl-12 m-auto">
              <DoneForYouContactForm />
            </div>
          </div>



        </div>
      </section>

      {/* <!-- end hero -->  */}
    </>
  );
};

export default ShowcaseMyImpact;
